<template>
  <div>
    <div class="delete-all text-right">
      <button class="btn btn-delete" @click.prevent="handleDeleteAllNotif">
        Supprimer toutes les notifications
      </button>
    </div>
    <div class="notifications-list">
      <vue-custom-scrollbar class="scroll-area" :settings="settings">
        <template v-for="(notif, index) in notifs">
          <div class="wrap-notif" :key="index" :id="'notif-' + notif.id">
            <a
              href="#"
              class="notification-wrapper"
              :class="{ nonlue: notif.etat === 1 }"
              @click.prevent="
                handleClickNotif(notif.id, notif.type, notif.entite)
              "
            >
              <div class="details">
                <span class="date">{{
                  notif.date_creation | moment('DD MMM YYYY HH:mm')
                }}</span>
                 <div class="call-to-action">
              <button class="link-btn" @click="handleClickLinkBtn(notif)">
                <font-awesome-icon :icon="['fas', 'link']" />
              </button>
              <button
                class="delete-btn"
                @click="handleDeleteNotification(notif.id)"
              >
                <font-awesome-icon :icon="['fas', 'trash-alt']" />
              </button>
            </div>
              </div>
              <div
                class="comment-block"
                v-html="notif.commentaire.commentaire"
              ></div>
            </a>

          </div>
        </template>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { mapActions, mapGetters } from 'vuex'
import { EventBus, events } from '../../../eventBus'
export default {
  components: {
    vueCustomScrollbar
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      notifs: []
    }
  },
  mounted () {
    this.getNotificationList()
    EventBus.$on(events.REFRESH_NOTIFICATION, () => {
      this.getNotificationList()
    })
  },
  methods: {
    ...mapGetters(['notifications']),
    ...mapActions(['setMessage', 'setIsFromNotif', 'getNotifications', 'setNotificationEtatVue', 'deleteNotification', 'setLinkComment', 'deleteAllNotifications']),
    handleClickLinkBtn (notif) {
      switch (notif.type) {
        case 'tableau_surface':
          // localStorage.setItem('notif_tds_tab', notif.entite)
          this.$router.push(`/mes-tableaux/${notif.projet.id}`)
          this.setLinkComment(notif)
          break
        case 'fiche_espace':
          this.$router.push(`/fiches-espaces/${notif.projet.id}`)
          this.setLinkComment(notif)
          break
        case 'schema_fonctionnel':
          this.$router.push(`/schemas-fonctionnels/${notif.projet.id}`)
          this.setLinkComment(notif)
          break
        case 'specification_technique':
          this.$router.push(`/specifications-techniques/${notif.projet.id}`)
          this.setLinkComment(notif)
          break
        case 'cahier_environnemental':
          this.$router.push(`/cahiers-environnemental/${notif.projet.id}`)
          this.setLinkComment(notif)
          break
        default:
          break
      }
    },
    async handleClickNotif (id, type, entite) {
      await this.setNotificationEtatVue(id)
      this.getNotificationList()
    },
    async getNotificationList () {
      await this.getNotifications()
      this.notifs = this.notifications()
    },
    async handleDeleteNotification (id) {
      this.$bvModal.msgBoxConfirm(`Voulez-vous vraiment supprimer la notification ?`, {
        modalClass: 'base-modal ',
        title: 'Suppression de notification',
        buttonSize: 'sm',
        headerClass: 'bg-danger',
        okVariant: 'outline-danger',
        okTitle: 'OUI',
        cancelVariant: 'outline-primary',
        cancelTitle: 'NON',
        footerClass: 'p-2',
        hideHeaderClose: true
      })
        .then(async value => {
          if (value) {
            await this.deleteNotification({ id: id })
            this.getNotificationList()
            this.setMessage('Supprimé')
            // this.$toaster.info('Notification supprimée avec succès', { timeout: 3000 })
          }
        })

      /* await this.deleteNotification({ id: id })
      this.getNotificationList() */
    },
    handleDeleteAllNotif () {
      this.$bvModal.msgBoxConfirm(`Voulez-vous vraiment supprimer toutes les notifications ?`, {
        modalClass: 'base-modal ',
        title: 'Suppression des notifications',
        buttonSize: 'sm',
        headerClass: 'bg-danger',
        okVariant: 'outline-danger',
        okTitle: 'OUI',
        cancelVariant: 'outline-primary',
        cancelTitle: 'NON',
        footerClass: 'p-2',
        hideHeaderClose: true
      })
        .then(async value => {
          if (value) {
            await this.deleteAllNotifications()
            this.getNotificationList()
            this.$toaster.info('Supprimé', { timeout: 3000 })
          }
        })
    }

  }

}
</script>

<style lang="scss" scoped>
.notifications-list {
  .scroll-area {
    height: calc(100vh - 245px);
    margin-right: -15px;
    padding-right: 15px;
    .ps__thumb-x, .ps__thumb-y {
      background-color: #2b3085 !important;
      width: 6px !important;
      right: 0;
      &:hover {
        background-color: #2b3085;
        width: 6px;
      }
    }
    .ps__rail-y {
      display: block;
      width: 8px;
      border: 1px solid #2b3085;
      border-radius: 6px;
    }
  }

}
.wrap-notif {
  position: relative;
  .call-to-action {
    /*position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);*/
    display: flex;
    button {
      border: none;
      background-color: transparent;
      box-shadow: none;
      color: #2b3085;
      font-size: 12px;
    }
  }
}
.notification-wrapper {
  box-shadow: 0 2px 3px 0 rgba(225, 225, 225, 0.5);
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #dfdfdf;
  margin-bottom: 10px;
  padding: 10px;
  font-family: "Open Sans";
  display: block;
  text-decoration: none !important;
  &.nonlue {
    background-color: rgba(0, 91, 165, 0.05);
    font-weight: 900;
  }
  .details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    .date {
      font-size: 11px;
      opacity: 0.5;
      color: #2b3085;
    }
  }
  .comment-block {
    font-size: 14px;
    color: #444444;
    text-decoration: none;
  }
}
.delete-all {
  margin-right: -15px;
  margin-left: -15px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #dfdfdf;
  .btn {
    margin-bottom: 0;
    border: 1px solid #2b3085;
    color: #2b3085;
    font-size: 14px;
    border-radius: 0;
    background-color: #fff;
    height: 25px;
    line-height: 25px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/voletLaterale/notifComponents/index.vue